import { gql } from "@apollo/client";

export const updateUserQuery = gql`
mutation updateUserQuery($id: String!, $username: String!, $email: String!, $admin: Boolean!, $viewer: Boolean!, $editor: Boolean!) {
  updateUser(id: $id, username: $username, email: $email, admin: $admin, editor: $editor, viewer: $viewer) {
    success
  }
}
`;
